import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Landing from './pages/Landing.jsx';
import Login from './pages/Login.jsx';
import Signup from './pages/Signup.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Track from './pages/Track.jsx';
import Enterprise from './pages/Enterprise.jsx';
import Recharge from './pages/Recharge.jsx';
import BookShipment from './pages/BookShipment.jsx';
import BulkUpload from './pages/BulkUpload.jsx';
import PickupAddresses from './pages/PickupAddresses.jsx';
import KYC from './pages/KYC.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import AllPages from './pages/AllPages.jsx';
import CPMGDemo from './pages/CPMGDemo.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public marketing surface */}
        <Route path="/" element={<Landing />} />
        <Route path="/track" element={<Track />} />
        <Route path="/enterprise" element={<Enterprise />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/join" element={<Signup />} />
        <Route path="/signup" element={<Signup />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/recharge" element={<Recharge />} />
        <Route path="/ship" element={<BookShipment />} />
        <Route path="/bulk" element={<BulkUpload />} />
        <Route path="/pickups" element={<PickupAddresses />} />
        <Route path="/kyc" element={<KYC />} />

        {/* Static admin pages showcase (8 internal pages, internal nav) */}
        <Route path="/admin/*" element={<AllPages />} />

        {/* Self-contained partner demo */}
        <Route path="/demo" element={<CPMGDemo />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
